import './modal.scss';

import Modal, {
  type ModalProps,
  type ModalSemanticClassNames
} from 'antd/lib/modal';
import React from 'react';

interface ChildrenArguments {
  classes: {
    actions: string;
    form: string;
  };
}

interface IProps extends Omit<ModalProps, 'children' | 'classNames'> {
  children?:
    | ((props: ChildrenArguments) => React.ReactElement)
    | React.ReactNode;
  onClose: () => void;
  classNames?: ModalSemanticClassNames;
}

const childrenClassNames: ChildrenArguments['classes'] = {
  actions: 'client-modal__actions',
  form: 'client-modal__form'
};

const getClassName = (classNames: (string | undefined)[]) => {
  return classNames.filter(Boolean).join(' ');
};

const CustomModal: React.FC<IProps> = ({ children, ...props }) => {
  return (
    <Modal
      centered
      mask={
        typeof props.mask === 'object'
          ? {
              closable: true,
              ...(props.mask ?? {})
            }
          : props.mask
      }
      {...props}
      classNames={{
        ...props.classNames,
        wrapper: getClassName([
          'client-modal-wrapper',
          props.classNames?.wrapper
        ]),
        header: getClassName([
          'client-modal__header',
          props.classNames?.header
        ]),
        body: getClassName(['client-modal__body', props.classNames?.body])
      }}
      className={`client-modal ${props.className ? props.className : ''}`}
      onCancel={props.onClose}
      footer={null}
    >
      {typeof children === 'function'
        ? children?.({ classes: childrenClassNames })
        : children}
    </Modal>
  );
};

export default CustomModal;
